/**
 * Phase 1 Integration Script - FIXED VERSION
 * Connects TTS, Detective Mentor, Sounds, and Confetti with the actual wizard logic
 */

(function () {
    'use strict';

    console.log('🎨 Phase 1 Integration initializing...');

    // Wait for DOM and all services to be ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    function init() {
        // Show mentor after page loads
        setTimeout(() => {
            if (window.DetectiveMentor) {
                window.DetectiveMentor.show();
                console.log('🕵️ Detective Mentor shown');
            }
        }, 500);

        // Setup audio buttons on dynamic content
        // setupDynamicAudioButtons(); // DISABLED: Using manual buttons for cleaner control

        // Test sounds (optional - remove in production)
        setupTestButtons();

        console.log('✅ Phase 1 Integration complete');
    }

    /**
     * Setup audio buttons that work with dynamic content
     */
    function setupDynamicAudioButtons() {
        // Use MutationObserver to detect when problem text appears
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        addAudioButtonsToElement(node);
                    }
                });
            });
        });

        // Observe the main content area
        const mainContent = document.getElementById('app') || document.body;
        observer.observe(mainContent, {
            childList: true,
            subtree: true
        });

        // Add buttons to existing content
        addAudioButtonsToElement(document.body);
    }

    /**
     * Add audio buttons to an element and its children
     */
    function addAudioButtonsToElement(element) {
        if (!window.AudioService) return;

        // Find problem statement (look for the collapsible panel)
        // Find problem statement (look for the collapsible panel)
        const problemPanels = element.querySelectorAll('[id*="problem"], .problem-statement, .card-content p');
        problemPanels.forEach(panel => {
            // Skip if inside option-card (those already have audio buttons from app.js)
            if (panel.closest('.option-card')) return;

            // Skip footer and branding
            if (panel.closest('.footer') || panel.closest('.branding') || panel.textContent.includes('SSWork')) return;

            // Skip wizard highlighting area (handled by wizardLogic.js)
            if (panel.closest('#highlightableText') || panel.closest('.highlight-area')) return;

            if (panel.textContent.trim().length > 20 && !panel.querySelector('.audio-btn')) {
                addAudioButton(panel);
            }
        });

        // Find step titles
        const stepTitles = element.querySelectorAll('h2, h3, .step-title, [class*="paso"]');
        stepTitles.forEach(title => {
            // Skip if inside option-card (those already have audio buttons from app.js)
            if (title.closest('.option-card')) return;
            // Skip if the title ALREADY contains an audio button (prevent double buttons)
            if (title.querySelector('.audio-btn') || title.querySelector('.btn-audio-inline')) return;

            if (title.textContent.trim().length > 5) {
                addAudioButton(title);
            }
        });
    }

    /**
     * Add audio button to a specific element
     */
    function addAudioButton(element) {
        // Skip if button already exists or element is a button itself
        if (element.querySelector('.audio-btn') || element.tagName === 'BUTTON') return;

        const button = document.createElement('button');
        button.className = 'audio-btn';
        button.innerHTML = '🔊';
        button.title = 'Escuchar';
        button.setAttribute('aria-label', 'Leer en voz alta');
        button.type = 'button';

        button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            // Get text to read
            const text = element.textContent.replace('🔊', '').trim();

            if (window.AudioService) {
                button.classList.add('playing');
                AudioService.speak(text);

                setTimeout(() => {
                    button.classList.remove('playing');
                }, 3000);
            }
        });

        // Position button
        if (window.getComputedStyle(element).position === 'static') {
            element.style.position = 'relative';
        }

        element.appendChild(button);
        console.log('🔊 Added audio button to:', element.tagName);
    }

    /**
     * Setup test buttons for development
     */
    function setupTestButtons() {
        // Listen for global test events
        window.testPhase1 = {
            sound: (type) => {
                console.log('🎵 Testing sound:', type);
                if (window.SoundService) {
                    SoundService.play(type);
                }
            },
            mentor: (state) => {
                console.log('🕵️ Testing mentor:', state);
                if (window.DetectiveMentor) {
                    window.DetectiveMentor.setState(state);
                }
            },
            confetti: () => {
                console.log('🎊 Testing confetti');
                if (window.confetti) {
                    confetti({
                        particleCount: 100,
                        spread: 70,
                        origin: { y: 0.6 }
                    });
                }
            },
            speak: (text) => {
                console.log('🔊 Testing TTS:', text);
                if (window.AudioService) {
                    AudioService.speak(text || '¡Hola! Soy el detective matemático.');
                }
            }
        };

        console.log('🧪 Test functions available: window.testPhase1');
    }

    // Expose utilities
    window.Phase1Integration = {
        addAudioButton: addAudioButton,
        init: init
    };

})();
